module.exports = __webpack_public_path__ + "static/img/Mask group.1c99742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20240302/Mask group.png
// module id = 97FB
// module chunks = 1